export default function CentorComponent() {
  return <></>;
}
